import { ResponseBody } from '@shared/model/response-body.models';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { map } from 'rxjs/operators';
import { identificationRequestData } from '@shared/model/idenification.model';
import { identificationInfo } from '@shared/model/identification-info.model';
import { IdentificationInfoRequest } from '@shared/model/request/identification-info-request.model';
import { MatSnackBar } from '@angular/material/snack-bar';

@Injectable({
  providedIn: 'root',
})
export class IdentificationService {
  private readonly baseUrl = environment.baseUrl;
  private readonly routePrefix = 'api/v1/admin/user/provider';

  constructor(private http: HttpClient, private snackBar: MatSnackBar) { }

  getIdentification(
    startPage: number,
    pageSize: number
  ): Observable<identificationRequestData> {
    return this.http
      .get(
        `${this.baseUrl}/${this.routePrefix}/verification-request?startPage=${startPage}&pageSize=${pageSize}`
      )
      .pipe(map((res: any) => res.data));
  }

  getIdentificationById(id: number): Observable<identificationInfo> {
    return this.http
      .get(`${this.baseUrl}/${this.routePrefix}/verification-request/${id}`)
      .pipe(map((res: any) => res.data));

  }

  postIdentificationById(id: number, data: IdentificationInfoRequest): Observable<ResponseBody> {
    return this.http.post(`${this.baseUrl}/${this.routePrefix}/verification-request/${id}`, data)
      .pipe(map((res: any) => {
        if (res.status === 200 || res.status === 201) {
          this.snackBar.open(res.message, 'Undo', {
            duration: 1000
          })
          return res.data
        }
      }
      ));

  }

}
